(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-black-friday"]) return;
  try {
    
  document.querySelectorAll('[data-bf-ticker-toggle]').forEach((button) => {
    button.hidden = false;
    button.addEventListener('click', () => {
      const ticker = button.closest('[data-bf-ticker]');
      const paused = ticker.toggleAttribute('data-paused');
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
    });
  });
  document.querySelectorAll('[data-black-friday] [data-bf-sort]').forEach((select) => {
    select.addEventListener('change', () => select.form.requestSubmit());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-black-friday-bundle"]) return;
  try {
    
  document.querySelectorAll('[data-bf-bundle]').forEach((root) => {
    const form = root.querySelector('.bf-bundle__form');
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('.bf-bundle__buy');
      const status = root.querySelector('[data-bf-bundle-status]');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      status.textContent = '';
      try {
        const response = await fetch(`${form.action}.js`, {method: 'POST', headers: {'Accept': 'application/json'}, body: new FormData(form)});
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(result.description || root.dataset.errorMessage);
        window.location.assign(root.dataset.cartUrl);
      } catch (error) {
        status.textContent = error.message || root.dataset.errorMessage;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
    root.querySelectorAll('[data-bf-bundle-size]').forEach((input) => {
      input.addEventListener('change', () => {
        const selected = root.querySelector('[data-bf-selected-size]');
        selected.textContent = `${selected.dataset.label} ${input.dataset.sizeTitle}`;
        root.querySelector('[data-bf-included-size]').textContent = input.dataset.sizeTitle;
      });
    });
    root.querySelector('[data-bf-size-guide]').addEventListener('click', (event) => {
      const chart = document.getElementById(event.currentTarget.hash.slice(1));
      if (!chart) return;
      event.preventDefault();
      chart.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
      chart.focus({preventScroll: true});
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-usat-exclusive-bundle"]) return;
  try {
    
  (() => {
    function setup(root) {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('form');
      const variants = JSON.parse(root.querySelector('[data-offer-variants]').textContent);
      const images = JSON.parse(root.querySelector('[data-goggle-images]').textContent);
      const select = root.querySelector('[data-variant-id]');
      const button = root.querySelector('.usat-offer__buy');
      const label = root.querySelector('[data-buy-label]');
      const status = root.querySelector('[data-offer-status]');
      const groups = [...root.querySelectorAll('[data-option-index]')];
      let busy = false;
      function update() {
        const selected = groups.map(group => group.querySelector('input:checked')?.value);
        const variant = variants.find(v => groups.every((group, index) => v.options[Number(group.dataset.optionIndex)] === selected[index]));
        select.value = variant ? String(variant.id) : '';
        button.disabled = busy || !variant?.available;
        label.textContent = busy ? root.dataset.busyLabel : variant?.available ? root.dataset.addLabel : root.dataset.soldLabel;
        groups.forEach(group => {
          const position = Number(group.dataset.optionIndex);
          group.querySelectorAll('input').forEach(input => {
            input.disabled = !variants.some(v => v.available && v.options[position] === input.value && groups.every(other => other === group || v.options[Number(other.dataset.optionIndex)] === other.querySelector('input:checked')?.value));
          });
        });
        if (variant) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', String(variant.id));
          window.history.replaceState({}, '', url);
          root.querySelector('[data-goggle-image]').src = variant.option2.includes('Pink') ? images.pink : images.teal;
        }
      }
      root.querySelector('[data-enhanced-options]').hidden = false;
      root.querySelector('[data-native-variant]').hidden = true;
      groups.forEach(group => group.addEventListener('change', () => { status.textContent = ''; update(); }));
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || !select.value || button.disabled) return;
        busy = true; status.textContent = ''; update();
        try {
          const data = new FormData(form);
          const response = await fetch(root.dataset.addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: data });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : root.dataset.errorLabel);
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          status.textContent = error.message || root.dataset.errorLabel;
          busy = false; update();
        }
      });
      update();
    }
    document.querySelectorAll('[data-usat-offer]').forEach(setup);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-usat-offer]').forEach(setup));
  })();

  } catch(e) { console.error(e); }
})();
})();
